import { Sidebar } from "./sidebar";
import { Header } from "./header";
import { useLayout } from "./context";
import { SidebarMenu } from "./sidebar-menu";

export function Wrapper({ children }: { children: React.ReactNode }) {
  const { isMobile } = useLayout();

  return (
    <>
      <Header />

      <div className="flex min-w-0 grow pt-(--header-height)">
        {!isMobile && <Sidebar />}

        <div className="flex min-w-0 grow flex-col lg:ps-(--sidebar-width)">
          <div className="flex min-w-0 flex-grow">
            {!isMobile && <SidebarMenu />}

            <main
              id="layout-content"
              tabIndex={-1}
              className="min-w-0 grow lg:ps-[var(--sidebar-menu-width)]"
            >
              {children}
            </main>
          </div>
        </div>
      </div>
    </>
  );
}
